module.exports = __webpack_public_path__ + "static/media/defaultAvatar1.9dd2b09b.svg";